// A link the app can't open, or a screen that failed to draw (security review 2, S6): say so calmly, offer the inbox.
import { navigate } from "../app/router";
import { Brand, Page } from "../components/Shell";

export function BrokenLink({ onHome }: { onHome?: () => void }) {
  const home = () => {
    onHome?.();
    navigate("/", { replace: true });
  };
  return (
    <>
      <header className="topbar">
        <Brand />
      </header>
      <Page tabs={false}>
        <div className="empty" role="alert">
          <h2>That link didn't work.</h2>
          <p>It may be cut short or out of date. Nothing was sent from this phone.</p>
          <button type="button" className="btn btn-primary btn-sm" onClick={home}>
            Go to the inbox
          </button>
        </div>
      </Page>
    </>
  );
}
